package com.xtream.data_kmp.db.utils

class XorEncDec() {
    companion object {
        fun encDec(msg: String?, key: String = ""): String {

            //return XorCipher.encDec( msg+"\r\n", key)

            return try {
                if (msg == null || key.isEmpty()) return ""
                val output = StringBuilder()
                val newMsg = msg

                for (i in newMsg.indices) {
                    val a: Int = newMsg[i].code
                    val b: Int = key[i % key.length].code
                    output.append((a xor b).toChar())
                }

                output.toString()
            } catch (e: Exception) {
                ""
            }
        }
    }
}